import React from "react";
import "../../assets/css/app.css";
import "./AboutUs.css";
import abtGirl from "../../assets/imgs/abtGirl.jpg";
import abtgrl2 from "../../assets/imgs/abtgrl2.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade"; 
import { NavLink } from "react-router-dom";

function AboutUs() {
  return (
    <div className="abtUs">
 
      <div className="maxW">
        <h2>ABOUT US</h2>
        <div className="abtMain">
          <div className="abtLft">
            <p>
              Established in 1991, a government-recognized company.
              A very fast-growing company with its motto and aim to work with
              customers with total honesty and dedication.
            </p>
            <p><strong>Area: </strong>Over 25,000 sq. ft. of state-of-the-art working space</p>
            <p><strong>Work Power: </strong>A dedicated team of 100+ skilled employees</p>
            <p><strong>Production Capacity: </strong>Capable of producing 100,000+ pieces
            per month*</p>
            
                  <NavLink to={"/AboutUs"}><button className="bnrBtn abBtn">LEARN MORE</button></NavLink>
          </div>
          <div className="abtRyt">
            <Swiper
              modules={[Autoplay, EffectFade]} 
              effect="fade"
              autoplay={{ delay: 2000 }} 
              className="mySwiper"
              loop={true}
            >
              <SwiperSlide>
                <img src={abtGirl} alt="abtGirl-img" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={abtgrl2} alt="abtGirl-img" />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
